"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeLoadingSchemaPropTypes = void 0;

var _reactDesc = require("react-desc");

var _spacingSchema = require("../../modifiers/spacingSchema");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var makeLoadingSchemaPropTypes = function makeLoadingSchemaPropTypes() {
  return _objectSpread({}, (0, _spacingSchema.makeSpacingSchemaPropTypes)(), {
    size: _reactDesc.PropTypes.oneOf(['small', 'medium', 'large']).description("The size in which to render the component's text and icon").defaultValue('medium'),
    variant: _reactDesc.PropTypes.oneOf(['normal', 'inverted']).description('Which loading variant to render.').defaultValue('normal')
  });
};

exports.makeLoadingSchemaPropTypes = makeLoadingSchemaPropTypes;
var schema = (0, _reactDesc.describe)({
  displayName: 'Loading'
});
schema.propTypes = makeLoadingSchemaPropTypes();
var _default = schema;
exports.default = _default;